import React from 'react';
import { ClassAssembly6C2025 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly6C2025/>;
  };
  
  export default ClassAssemblyPage;